module.exports = __webpack_public_path__ + "img/Unidad7-3.d1c7df68.png";